/**
 * Fires a custom event
 * @param {String} eventName The name of the event
 * @param {Object} eventData Additional data pushed for listeners
 * @param {Element} source Element that will fire the event. Defaults to document.
 * @void
 */
 const fireEvent = function (eventName, eventData = {}, source = null) {
  const origin = source || document;
  origin.dispatchEvent(
    new CustomEvent(eventName, {
      detail: eventData
    })
  );
};

export default  {
  fireEvent: fireEvent
}